import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgMessenger = function SvgMessenger(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.36 22.375 6.818 27l5.574-1.186c2.27 1.102 4.913 1.434 7.438.934 2.525-.5 4.76-1.799 6.288-3.653 1.529-1.855 2.248-4.14 2.024-6.43-.225-2.291-1.377-4.431-3.244-6.023-1.866-1.592-4.32-2.527-6.903-2.632-2.584-.105-5.123.628-7.145 2.062-2.022 1.435-3.388 3.473-3.846 5.736-.459 2.262.023 4.596 1.356 6.567Zm14.513-5.092a1.15 1.15 0 1 0-1.275-1.913l-2.774 1.849-1.705-1.706a1.15 1.15 0 0 0-1.451-.143l-3.558 2.372a1.15 1.15 0 1 0 1.276 1.913l2.773-1.849 1.706 1.706a1.15 1.15 0 0 0 1.45.143l3.558-2.372Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgMessenger;